// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductDetail_container__FX6xF","wrapper":"ProductDetail_wrapper__Fca32","productColumn":"ProductDetail_productColumn__ubSw3"};